module.exports = __webpack_public_path__ + "static/media/shirts.21634752.png";